<!-- 单行文本 -->
<template>
    <div v-if="componentsData.type == 2">
        <div class="bg-div" :style="bgStyle">
            <template v-if="componentsData.content.select_style == 1">
                <div
                    v-if="componentsData.content.title"
                    class="title-box"
                    :style="titleStyle"
                >
                    {{ componentsData.content.title }}
                </div>
                <div class="pb8" :style="textStyle1">
                    {{
                        componentsData.content.pre_filled_content
                            ? componentsData.content.pre_filled_content
                            : componentsData.content.prompt_text
                    }}
                </div>
                <div
                    v-if="componentsData.content.error_message"
                    class="mt8"
                    :style="textStyle2"
                >
                    {{ componentsData.content.error_message }}
                </div>
            </template>
            <template v-else-if="componentsData.content.select_style == 2">
                <div
                    v-if="componentsData.content.title"
                    class="title-box"
                    :style="titleStyle"
                >
                    {{ componentsData.content.title }}
                </div>
                <div class="p6" :style="textStyle3">
                    {{
                        componentsData.content.pre_filled_content
                            ? componentsData.content.pre_filled_content
                            : componentsData.content.prompt_text
                    }}
                </div>
                <div
                    v-if="componentsData.content.error_message"
                    class="mt8"
                    :style="textStyle2"
                >
                    {{ componentsData.content.error_message }}
                </div>
            </template>
            <template v-else-if="componentsData.content.select_style == 3">
                <div class="p6 flex-sb" :style="textStyle3">
                    <div
                        v-if="componentsData.content.title"
                        class="title-box2"
                        :style="titleStyle"
                    >
                        {{ componentsData.content.title }}
                    </div>
                    <div>
                        {{
                            componentsData.content.pre_filled_content
                                ? componentsData.content.pre_filled_content
                                : componentsData.content.prompt_text
                        }}
                    </div>
                </div>
                <div
                    v-if="componentsData.content.error_message"
                    class="mt8"
                    :style="textStyle2"
                >
                    {{ componentsData.content.error_message }}
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    computed: {
        textStyle1() {
            const content = this.componentsData.content;
            return {
                borderBottom: `1px solid ${content.border_color}`,
                color: content.pre_filled_content
                    ? content.enter_text_color
                    : content.prompt_text_color,
            };
        },
        textStyle2() {
            const content = this.componentsData.content;
            return {
                fontSize: `${content.error_message_size}px`,
                color: content.error_message_color,
            };
        },
        textStyle3() {
            const content = this.componentsData.content;
            return {
                backgroundColor: content.fill_color,
                border: `1px solid ${content.border_color}`,
                color: content.pre_filled_content
                    ? content.enter_text_color
                    : content.prompt_text_color,
            };
        },
        titleStyle() {
            const content = this.componentsData.content;
            return {
                color: content.title_color,
            };
        },
        bgStyle() {
            const content = this.componentsData.content;
            const style = {};
            if (content.bg_color) {
                style.backgroundColor = content.bg_color;
            }
            const bgImg = content.bg_img || {};
            if (bgImg.picview && content.bg_value) {
                style.backgroundImage = `url(${bgImg.picview})`;
            }
            style.padding = `${content.inner_spacing.top}px ${content.inner_spacing.left}px`;
            style.margin = `${content.outer_spacing.top}px ${content.outer_spacing.left}px`;
            style.borderRadius = `${content.rounded_corner_setting.top}px ${content.rounded_corner_setting.top}px ${content.rounded_corner_setting.bottom}px ${content.rounded_corner_setting.bottom}px`;
            return style;
        },
    },
};
</script>

<style scoped>
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    font-size: 15px;
}
.mt8 {
    margin-top: 8px;
}
.pb8 {
    padding-bottom: 8px;
}
.p6 {
    padding: 6px;
}
.title-box {
    margin-bottom: 8px;
    font-size: 18px;
}
.title-box2 {
    font-size: 18px;
}
</style>
